@if (isVisible()) {
  <div
    class="offline-overlay"
    aria-hidden="true"
  ></div>
}
